/**
 * Created by r4zi4l on 17.05.2021
 */

const PassProgress = cc.Node.extend({
    ctor: function (options) {
        this._super();
        this.passLogic = options.passLogic;

        const styles = cleverapps.styles.PassProgress;

        this.setContentSize2(options.width - 2 * styles.paddingX, styles.height);

        const tasks = this.createTasks();

        const progressBar = this.progressBar = new ScaledProgressBar({
            progress: bundles.progress_bar.frames.bar_passprogress,
            background: bundles.progress_bar.frames.bg_passprogress
        });
        progressBar.setLength(tasks.content.width - styles.tasks.width / 2 - styles.progressBar.offsetWidth);
        progressBar.setAnchorPoint(0, 0.5);
        progressBar.setAlignment(styles.progressBar);
        progressBar.setLocalZOrder(-1);
        progressBar.setPercentage(this.calcProgressPercentage(this.passLogic.shownProgress));
        tasks.content.addChild(progressBar);

        if (cleverapps.config.debugMode) {
            cleverapps.UI.onClick(progressBar, () => {
                this.passLogic.completeCurrentTask();
                this.passLogic.showProgress();
            });
        }

        this.addLines();

        const scroll = this.progressScroll = new cleverapps.UI.ScrollView(tasks, {
            childrenVisibility: false,
            direction: cleverapps.UI.ScrollView.DIR_HORIZONTAL,
            scrollBarEnabled: false,
            outOfBoundaryScale: 0.05
        });
        scroll.setContentSize2(this.width + styles.scroll.offsetWidth, this.height + styles.scroll.offsetHeight);
        scroll.scrollTo(cleverapps.UI.ScrollView.SCROLLS.LOWER_RIGHT);
        scroll.setAlignment(styles.scroll);
        this.addChild(scroll);

        this.passLogic.onAnimateProgressChange = this.createListener(this.animateProgressChange.bind(this));
        this.passLogic.onNextProgressStep = this.createListener(this.animateProgressStep.bind(this));
        this.passLogic.onShowFinger = this.createListener(this.showFinger.bind(this));
        this.passLogic.onHideFinger = this.createListener(this.hideFinger.bind(this));
        this.passLogic.onShowWindowListeners.passProgress = this.createListener(this.onShow.bind(this));
    },

    createTasks: function () {
        const styles = cleverapps.styles.PassProgress.tasks;
        const tasks = this.passLogic.levels;

        const container = this.container = new cc.Node();
        container.setAnchorPoint(0.5, 0.5);
        container.setContentSize2(styles.width * tasks.length + styles.contentOffset, styles.height);

        const rewardIcons = this.rewardIcons = [];
        const createIcon = function (level, premium) {
            const icon = new PassRewardIcon({
                passLogic: this.passLogic,
                level,
                premium
            });
            icon.setAlignment(styles.width * (0.5 + level), premium ? styles.premiumReward.y : styles.reward.y);
            icon.setLocalZOrder(tasks.length - level);
            this.container.addChild(icon);
            rewardIcons.push(icon);
        }.bind(this);

        tasks.forEach((task, index) => {
            createIcon(index, false);
            createIcon(index, true);
        });

        this.updateIcons();
        this.createTaskPoints();
        this.createTasksBgs();

        const wrap = cleverapps.UI.wrapWithPadding(container, { left: styles.contentOffset });
        wrap.content = container;

        return wrap;
    },

    createTaskPoints: function () {
        this.taskPoints = this.passLogic.levels.map(function (task, index) {
            const taskPoint = this.createTaskPoint(task, index);
            this.container.addChild(taskPoint);
            return taskPoint;
        }, this);
    },

    createTaskPoint: function (task, index) {
        const curLevel = this.passLogic.shownProgress.level;

        const isComplete = curLevel > task.level;

        if (isComplete) {
            return this.createCompletedTaskPoint(task, index);
        }

        return this.createUncompletedTaskPoint(task, index);
    },

    createCompletedTaskPoint: function (task, index) {
        const styles = cleverapps.styles.PassProgress.tasks;

        const frame = bundles.passprogress.frames[this.passLogic.mission.taskPointCompleted] || bundles.passprogress.frames.task_point_completed;

        const taskPoint = new cc.Sprite(frame);
        taskPoint.setAlignment(styles.width * (0.5 + index), styles.taskPoint.y);

        if (styles.completedLevelIcon) {
            const icon = new cc.Sprite(this.passLogic.getCollectIcon());
            taskPoint.addChild(icon);
            icon.setAlignment(styles.completedLevelIcon);
        } else {
            const numb = cleverapps.UI.generateImageText(index + 1, cleverapps.styles.FONTS.PASS_PROGRESS_POINT_COMPLETED);
            taskPoint.addChild(numb);
            numb.setAlignment(taskPoint.width / 2, taskPoint.height / 2 + styles.taskPoint.completedNumberDy);
        }

        return taskPoint;
    },

    createUncompletedTaskPoint: function (task, index) {
        const styles = cleverapps.styles.PassProgress.tasks;

        const taskPoint = new cc.Sprite(bundles.passprogress.frames.task_point);
        taskPoint.setAlignment(styles.width * (0.5 + index), styles.taskPoint.y);

        const numb = cleverapps.UI.generateImageText(index + 1, cleverapps.styles.FONTS.PASS_PROGRESS_POINT);

        taskPoint.addChild(numb);
        numb.setAlignment(taskPoint.width / 2, taskPoint.height / 2 + styles.taskPoint.numberDy);

        return taskPoint;
    },

    createTasksBgs: function () {
        const styles = cleverapps.styles.PassProgress;

        const createBg = function (prem, index) {
            const bg = cleverapps.UI.createScale9Sprite(bundles.passprogress.frames[prem ? "prize_bg_orange1" : "prize_bg_blue1"]);
            bg.setContentSize2(styles.tasks.bgs);
            bg.setAlignment(styles.tasks.width * (0.5 + index), prem ? styles.line.first.y : styles.line.second.y);
            this.container.addChild(bg, -1);
        }.bind(this);

        this.passLogic.levels.forEach((task, index) => {
            if (index % 2 === 0 && !bundles.passprogress.frames.prize_bg_single) {
                return;
            }
            createBg(true, index);
            createBg(false, index);
        }, this);
    },

    addIcons: function (icons, x, y) {
        const layout = new cleverapps.Layout(icons, {
            direction: cleverapps.UI.VERTICAL,
            reversed: true
        });
        layout.setAnchorPoint(0.5, 0.5);
        layout.setAlignment(x, y);
        this.container.addChild(layout);
        return layout;
    },

    addLines: function () {
        const styles = cleverapps.styles.PassProgress.line;
        const createLine = function (img, pos) {
            const line = cleverapps.UI.createScale9Sprite(img, styles.scale9 ? styles.scale9 : undefined);
            line.setAlignment(pos);
            line.setContentSize2(this.width, styles.height);
            this.addChild(line, -2);
        }.bind(this);

        if (bundles.passprogress.frames.prize_bg_single) {
            createLine(bundles.passprogress.frames.prize_bg_single, styles.single);
        } else {
            createLine(bundles.passprogress.frames.prize_bg_orange2, styles.first);
            createLine(bundles.passprogress.frames.prize_bg_blue2, styles.second);
        }
    },

    calcProgressPercentage: function (progress) {
        const total = this.passLogic.levels.length;

        if (progress.level >= total) {
            return 100;
        }

        if (progress.level === 0 && progress.progress === 0) {
            return 0;
        }

        const firstStageStep = 0.5 / total;
        const goal = progress.progress / this.passLogic.levels[progress.level].task.goal;

        if (progress.level === 0) {
            return firstStageStep * goal * 100;
        }
        return (firstStageStep + (1 - firstStageStep) / (total - 1) * (progress.level - 1 + goal)) * 100;
    },

    scrollToLevel: function (duration, level, options) {
        if (this.taskPoints[level]) {
            this.progressScroll.scrollTo(this.taskPoints[level].getPosition(), duration, options);
        }
    },

    animateProgressChange: function (nextProgress, f) {
        this.scrollToLevel(0.8, nextProgress.level);

        const percentage = this.calcProgressPercentage(nextProgress);
        this.progressBar.runAction(new ScaledProgressBarProgressTo(0.8, percentage).easing(cc.easeCubicActionOut()));

        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.6)
        )).setFinalize(f);
    },

    animateProgressStep: function (finishedLevel, f) {
        const taskPoint = this.taskPoints[finishedLevel];

        const completedTaskPoint = this.createCompletedTaskPoint(this.passLogic.levels[finishedLevel], finishedLevel);
        this.container.addChild(completedTaskPoint);
        completedTaskPoint.setAlignment(taskPoint.getPosition());
        this.taskPoints[finishedLevel] = completedTaskPoint;

        taskPoint.removeFromParent();

        completedTaskPoint.runAction(new cc.Sequence(
            new cc.ScaleTo(0.2, 1.15),
            new cc.ScaleTo(0.15, 1)
        ));

        completedTaskPoint.runAction(new cc.Sequence(
            new cc.ScaleTo(0.2, 1.15),
            cleverapps.effects.fireAction("mission.passprogress.task.done"),
            new cc.CallFunc(() => {
                this.rewardIcons.filter((icon) => icon.options.level === finishedLevel).forEach((icon) => {
                    icon.updateState(finishedLevel + 1);
                    icon.openAnimation();
                });

                if (this.passLogic.levels[finishedLevel].energy) {
                    Map2dLocation.currentLocation.addReward("energy", this.passLogic.levels[finishedLevel].energy, completedTaskPoint);
                }
            }),
            new cc.ScaleTo(0.15, 1)
        )).setFinalize(f);
    },

    updateIcons: function () {
        this.rewardIcons.forEach((icon) => {
            icon.updateState();
        });
    },

    showFinger: function () {
        const reward = this.getFirstShownReward();
        if (reward) {
            const icon = this.rewardIcons.filter((icon) => icon.options.level === reward.level && icon.options.premium === reward.premium)[0];
            this.finger = FingerView.hintTap(icon, {
                delay: 1.6,
                loopFilter: function () {
                    return cc.rectContainsRect(this.progressScroll.getGlobalBoundingBox(), icon.icon.getGlobalBoundingBox());
                }.bind(this)
            });
        }
    },

    hideFinger: function () {
        FingerView.remove(this.finger);
        this.finger = undefined;
    },

    onShow: function () {
        const task = this.passLogic.shownProgress;
        let level = task.level;
        if (this.passLogic.isAllProgressShown()) {
            const reward = this.getFirstShownReward();
            if (reward !== undefined) {
                level = reward.level;
            }
        }

        this.hideFinger();
        this.updateIcons();

        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.4),
            new cc.CallFunc(() => {
                this.scrollToLevel(0.8, level, {
                    easing: cc.easeBackInOut(),
                    callback: () => this.passLogic.showProgress()
                });
            })
        ));
    },

    getFirstShownReward: function () {
        for (let i = 0, l = this.passLogic.shownProgress.level; i < l; ++i) {
            if (this.passLogic.hasPremium() && this.passLogic.hasReward(i, true)) {
                return {
                    level: i,
                    premium: true
                };
            }

            if (this.passLogic.hasReward(i)) {
                return {
                    level: i,
                    premium: false
                };
            }
        }
        return undefined;
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    PASS_PROGRESS_POINT: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE
    },

    PASS_PROGRESS_POINT_COMPLETED: {
        name: "nostroke",
        size: 40,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    }
});

cleverapps.styles.PassProgress = {
    paddingX: 122,
    height: 700,

    scroll: {
        x: { align: "center", dx: -1 },
        y: { align: "center", dy: 0 },
        offsetHeight: 100,
        offsetWidth: 0
    },

    progressBar: {
        offsetWidth: 5,
        x: { align: "left", dx: 0 },
        y: { align: "center", dy: 1 }
    },

    line: {
        first: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 159 }
        },
        second: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: -151 }
        },
        height: 311
    },

    tasks: {
        width: 220,
        height: 500,
        contentOffset: 30,

        taskPoint: {
            y: { align: "center" },

            numberDy: 0,
            completedNumberDy: 0
        },

        premiumReward: {
            y: { align: "center", dy: 188 }
        },

        reward: {
            y: { align: "center", dy: -140 }
        },

        bgs: {
            width: 220,
            height: 311
        }
    }
};
